import { motion } from "framer-motion";

import manager1 from "../asserts/Sriram.png";
import manager2 from "../asserts/Ragul.png";
import manager3 from "../asserts/Thulasi1.png";


/* =========================================================
   ANIMATIONS
========================================================= */

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 35,
  },

  visible: {
    opacity: 1,
    y: 0,

    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};


const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -50,
  },

  visible: {
    opacity: 1,
    x: 0,

    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};


const fadeRight = {
  hidden: {
    opacity: 0,
    x: 50,
  },

  visible: {
    opacity: 1,
    x: 0,

    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};


/* =========================================================
   LEADERSHIP DATA
========================================================= */

const managers = [
  {
    name: "Sriram Neelamegam",

    role: "Founder & CEO",

    image: manager1,

    description:
      "Leads WE3X with a focus on strategic direction, innovation and sustainable growth, connecting education, technology and digital solutions under one vision.",
  },

  {
    name: "Ragul Prasanth A",

    role: "Co-Founder & CTO",

    image: manager2,

    description:
      "Drives the technology division at WE3X, guiding software development, digital products and business automation with a strong focus on practical and scalable solutions.",
  },

  {
    name: "Thulasi Ragul Raj K",

    role: "Co-Founder & CMO",

    image: manager3,

    description:
      "Leads brand growth and digital strategy across SEO, social media, paid campaigns and content, helping businesses build visibility and meaningful customer connections.",
  },
];


/* =========================================================
   LEADERSHIP SECTION
========================================================= */

export default function LeadershipSection() {
  return (
    <section
      className="
        relative
        overflow-hidden
        bg-white
        py-20
        sm:py-24
        lg:py-32
      "
    >
      <div
        className="
          mx-auto
          max-w-7xl
          px-5
          sm:px-8
          lg:px-10
        "
      >

        {/* =====================================================
            SECTION HEADING
        ===================================================== */}

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
          }}
          className="
            mx-auto
            mb-16
            max-w-3xl
            text-center
            lg:mx-0
            lg:mb-20
            lg:text-left
          "
        >

          {/* LABEL */}

          <div
            className="
              mb-5
              flex
              items-center
              justify-center
              gap-3
              text-xs
              font-bold
              uppercase
              tracking-[0.22em]
              text-blue-600
              lg:justify-start
            "
          >
            <span
              className="
                h-[1px]
                w-10
                bg-blue-600
              "
            />

            Our Leadership
          </div>


          {/* TITLE */}

          <h2
            className="
              merriweather
              text-3xl
              font-black
              tracking-[-0.04em]
              text-neutral-950
              sm:text-4xl
              lg:text-[52px]
              lg:leading-[1.08]
            "
          >
            Meet the people shaping

            <span
              className="
                block
                text-blue-600
              "
            >
              the direction of WE3X.
            </span>
          </h2>


          {/* DESCRIPTION */}

          <p
            className="
              mx-auto
              mt-6
              max-w-2xl
              text-[15px]
              leading-8
              text-neutral-600
              sm:text-[16px]
              lg:mx-0
            "
          >
            Meet the leadership team guiding WE3X across professional
            education, technology development and digital growth.
          </p>

        </motion.div>



        {/* =====================================================
            MANAGERS
        ===================================================== */}

        <div>
          {managers.map((manager, index) => (
            <ManagerRow
              key={manager.name}
              manager={manager}
              reverse={index % 2 !== 0}
            />
          ))}
        </div>

      </div>
    </section>
  );
}



/* =========================================================
   MANAGER ROW
========================================================= */

function ManagerRow({
  manager,
  reverse,
}) {
  return (
    <div
      className="
        relative
        border-t
        border-neutral-200
        py-14
        sm:py-16
        lg:py-20
      "
    >

      {/* =====================================================
          MOBILE:
          IMAGE
          ↓
          CONTENT CENTERED

          DESKTOP:
          IMAGE | CONTENT
          CONTENT | IMAGE
      ===================================================== */}

      <div
        className="
          grid
          items-center
          gap-9
          lg:grid-cols-2
          lg:gap-20
        "
      >

        {/* =====================================================
            IMAGE
        ===================================================== */}

        <motion.div
          variants={
            reverse
              ? fadeRight
              : fadeLeft
          }
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          className={`
            relative

            ${
              reverse
                ? "lg:order-2"
                : "lg:order-1"
            }
          `}
        >

          <div
            className="
              relative
              mx-auto
              w-full
              max-w-[430px]
              overflow-hidden
              lg:mx-0
            "
          >

            {/* PORTRAIT */}

            <motion.img
              src={manager.image}
              alt={`${manager.name}, ${manager.role} at WE3X`}
              initial={{
                scale: 1.05,
              }}
              whileInView={{
                scale: 1,
              }}
              viewport={{
                once: true,
              }}
              transition={{
                duration: 1,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="
                relative
                z-10
                mx-auto
                h-[360px]
                w-full
                object-contain
                object-bottom
                sm:h-[420px]
                lg:h-[460px]
              "
            />

          </div>

        </motion.div>



        {/* =====================================================
            CONTENT

            MOBILE = CENTER
            DESKTOP = LEFT ALIGN
        ===================================================== */}

        <motion.div
          variants={
            reverse
              ? fadeLeft
              : fadeRight
          }
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          className={`
            mx-auto
            flex
            max-w-xl
            flex-col
            items-center
            text-center

            lg:mx-0
            lg:items-start
            lg:text-left

            ${
              reverse
                ? "lg:order-1"
                : "lg:order-2"
            }
          `}
        >

          {/* ROLE */}

          <div
            className="
              flex
              items-center
              justify-center
              gap-3
              text-[11px]
              font-bold
              uppercase
              tracking-[0.2em]
              text-blue-600
              lg:justify-start
            "
          >
            <span
              className="
                h-2
                w-2
                rounded-full
                bg-blue-600
              "
            />

            {manager.role}
          </div>


          {/* NAME */}

          <h3
            className="
              merriweather
              mt-4
              text-3xl
              font-black
              tracking-[-0.035em]
              text-neutral-950
              sm:text-4xl
              lg:text-[44px]
            "
          >
            {manager.name}
          </h3>


          {/* DIVIDER */}

          <div
            className="
              my-6
              h-[1px]
              w-16
              bg-neutral-300
            "
          />


          {/* DESCRIPTION */}

          <p
            className="
              max-w-lg
              text-[15px]
              leading-8
              text-neutral-600
              sm:text-[16px]
            "
          >
            {manager.description}
          </p>


          {/* BRAND TEXT */}

          <div
            className="
              mt-8
              flex
              items-center
              justify-center
              gap-3
              text-xs
              font-semibold
              text-neutral-400
              lg:justify-start
            "
          >
            <span
              className="
                h-[1px]
                w-8
                bg-neutral-300
              "
            />

            Leadership · WE3X
          </div>

        </motion.div>

      </div>

    </div>
  );
}